<div class="input-group">
    <input type="text"
           [formControl]="searchTerm"
           (keydown.enter)="doSearch(searchTerm.value)"
           class="shadow-sm focus:ring-primary-500 focus:border-primary-500 block w-full sm:text-sm border-gray-300 rounded-md"
           placeholder="Search..."
           aria-label="Search input">
</div>
